import React, { Component } from 'react';
import './AccountSettings.css';
import { toast } from 'react-toastify';
import {SessionContext} from './SessionContext.js';
import {Section} from '../Common.js';

class AccountSettings extends Component {
  static contextType = SessionContext;  

  state = this.initialState = {
    first_name: '',
    last_name: '',
    username: '',
    primaryEmailId: '',
    password: '',
    password2: '',
    new_address: '',
    blacklist_action: 0,
    subject_prefix: ''
  }

  async componentDidMount() {
    this.API = this.context.actions.getAPI();
    this.loadUserProfile();
    this.loadAddresses();
  }

  async loadAddresses() {
    let addresses = await this.API.getUserEmailAddresses(this.context.user.id);
    this.setState({addresses: addresses});
  }

  async loadUserProfile() {
    let user = await this.API.getUserProfile();
    if (user) {
      this.setState({
        first_name: user.first_name,
        last_name: user.last_name,
        username: user.username,
        primaryEmailId: user.primary_user_email_address_id ?? '',
        password: null,
        password2: null,
        blacklist_action: user.blacklist_action || 0,
        subject_prefix: user.subject_prefix || ''
      });
    } else {
      toast.error('Error loading user profile');
    }
  }  

  async handleAccountSave(e) {
    e.preventDefault();
    console.log("Saving account settings")

    let profile = {
      "id": this.context.user.id,
      "username": this.state.username,
      "first_name": this.state.first_name,
      "last_name": this.state.last_name,
      "primary_user_email_address_id": this.state.primaryEmailId,
      "password": this.state.password,
      "password2": this.state.password2,
      "blacklist_action": this.state.blacklist_action,
      "subject_prefix": this.state.subject_prefix
    }
    try {
      await this.API.saveUserProfile(profile);
      toast.success('Settings Saved');
    } catch(e) {
      console.log(e.message);
      toast.error(e.message);
    }
    this.setState(this.initialState);
    this.loadUserProfile();
    this.context.actions.reloadUser();
  }
  handleAccountSave = this.handleAccountSave.bind(this);

  accountSettingsSection() {
    let addresses = null;
    if (this.state.addresses) {
      addresses = this.state.addresses.map((x) => {
        return <option key={x.id} value={x.id}>{x.address}</option>      
      });
      if (addresses.length === 0)
        addresses = [<option key={""} value={"-none-"}>No addresses added</option>]
      else
        // primary_user_email_address_id is nullable, so "not chosen yet" is a
        // real state the control has to be able to show and submit. Without
        // this the select would silently display the first address for an
        // account that has none set.
        addresses.unshift(<option key={"unset"} value={""}>-- none selected --</option>)
    }
    
    return (
      <Section name="Account Settings">
        <div className="card">
          <div className="card-content">
            <form onSubmit={this.handleAccountSave}>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="form-group">
                  <label className="form-label">First Name</label>
                  <input 
                    type="text"
                    className="form-input"
                    value={this.state.first_name}
                    onChange={(e) => this.setState({first_name: e.target.value})}
                    placeholder="Enter your first name"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Last Name</label>
                  <input 
                    type="text"
                    className="form-input"
                    value={this.state.last_name}
                    onChange={(e) => this.setState({last_name: e.target.value})}
                    placeholder="Enter your last name"
                  />
                </div>
              </div>

              <div className="form-group mb-6">
                <label className="form-label">Username</label>
                <input 
                  type="text"
                  className="form-input"
                  value={this.state.username}
                  onChange={(e) => this.setState({username: e.target.value})}
                  placeholder="Your login username"
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <input 
                    type="password"
                    className="form-input"
                    onChange={(e) => this.setState({password: e.target.value})}
                    placeholder="Leave blank to keep current"
                  />
                  <div className="form-help">Only enter if you want to change your password</div>
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm New Password</label>
                  <input 
                    type="password"
                    className="form-input"
                    onChange={(e) => this.setState({password2: e.target.value})}
                    placeholder="Confirm new password"
                  />
                </div>
              </div>

              <div className="form-group mb-6">
                <label className="form-label">Primary Email Address</label>
                <select 
                  className="form-input"
                  value={this.state.primaryEmailId}
                  onChange={(e) => this.setState({primaryEmailId: e.target.value})}
                >
                  {addresses}
                </select>
                <div className="form-help">This email receives notifications and forwards</div>
              </div>

              <div className="text-center">
                <button type="submit" className="btn btn-primary btn-lg">
                  Save Account Settings
                </button>
              </div>
            </form>
          </div>
        </div>
      </Section>
    );
  }

  async handleAddAddress(e) {
    e.preventDefault();
    console.log("Adding Address")

    try {
      await this.API.addUserEmailAddress(this.context.user.id, this.state.new_address);
      toast.info('Email Address added');
    } catch(e) {
      console.log(e.message);
      toast.error(e.message);
    }
    this.setState({new_address: ''});
    this.loadAddresses();
  }
  handleAddAddress = this.handleAddAddress.bind(this);

  async deleteAddress(address) {
    if (window.confirm("Are you sure you want to delete '" + address.address + "'?")) {      
      try {
        await this.API.deleteUserEmailAddress(this.context.user.id, address.id);
        toast.info('Deleted address ' + address.address);
      } catch(e) {
        console.log(e);
        toast.error('Error deleting address. Try again later.');
      }
      this.loadAddresses();
    }
  }

  async resendVerification(address) {
    try {
      let response = await this.API.verifyUserEmailAddress(this.context.user.id, address.id);    
      toast.info(response.message);
    } catch(e) {
      console.log(e);
      toast.error('Error sending verification.  Try again later.');
    }
  }

  emailVerificationLink(email) {
    if (email.verified_on)
      return <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-success-500 bg-green-50 rounded-full">✓ Verified</span>
    else
      return <button 
        className="btn btn-ghost btn-sm text-warning-500" 
        onClick={() => {this.resendVerification(email); return false;}}
      >
        Resend Verification
      </button>
  }

  emailAddressesSection() {
    return (
      <Section name="Email Addresses">
        <div className="card">
          <div className="card-content">
            <form onSubmit={this.handleAddAddress} className="mb-6">
              <div className="form-group mb-4">
                <label className="form-label">Add New Email Address</label>
                <div className="flex gap-2">
                  <input 
                    type="email"
                    className="form-input flex-1"
                    placeholder="your.email@example.com"
                    value={this.state.new_address}
                    onChange={(e) => this.setState({new_address: e.target.value})}
                  />
                  <button type="submit" className="btn btn-primary" style={{height: '40px', padding: '0 16px', fontSize: '14px'}}>
                    Add
                  </button>
                </div>
              </div>
            </form>

            {this.state.addresses && this.state.addresses.length > 0 && (
              <div>
                <h3 className="font-semibold text-gray-900 mb-4">Your Email Addresses</h3>
                <div className="space-y-3">
                  {this.state.addresses.map((address) => (
                    <div key={address.id} className="flex items-center py-2 rounded px-2 -mx-2 email-row">
                      <span className="font-medium text-gray-900" style={{minWidth: '280px'}}>{address.address}</span>
                      <div className="ml-4" style={{minWidth: '140px'}}>
                        {this.emailVerificationLink(address)}
                      </div>
                      <button 
                        className="ml-4 hover:opacity-75"
                        onClick={() => this.deleteAddress(address)}
                        title="Delete Address"
                        style={{background: 'none', border: 'none', padding: '2px', cursor: 'pointer'}}
                      >
                        <img src="/images/trash.gif" alt="Delete" style={{width: '16px', height: '16px'}} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {(!this.state.addresses || this.state.addresses.length === 0) && (
              <div className="text-center py-8 text-gray-500">
                No email addresses added yet. Add one above to get started.
              </div>
            )}
          </div>
        </div>
      </Section>
    )
  }

  async handleEmailSettingsSave(e) {
    e.preventDefault();
    console.log("Saving email settings")

    let profile = {
      "id": this.context.user.id,
      "blacklist_action": this.state.blacklist_action,
      "subject_prefix": this.state.subject_prefix
    }
    try {
      await this.API.saveUserProfile(profile);
      toast.success('Email Settings Saved');
    } catch(e) {
      console.log(e.message);
      toast.error(e.message);
    }
    this.loadUserProfile();
  }
  handleEmailSettingsSave = this.handleEmailSettingsSave.bind(this);

  emailSettingsSection() {
    return (
      <Section name="Email Settings">
        <div className="card">
          <div className="card-content">
            <form onSubmit={this.handleEmailSettingsSave}>
              <div className="form-group mb-6">
                <label className="form-label">Spam Handling</label>
                <select 
                  className="form-input"
                  value={this.state.blacklist_action}
                  onChange={(e) => this.setState({blacklist_action: parseInt(e.target.value)})}
                >
                  <option value={0}>Add prefix to subject line</option>
                  <option value={1}>Delete spam messages completely</option>
                </select>
                <div className="form-help">Choose how spam messages should be handled</div>
              </div>

              <div className="form-group mb-6">
                <label className="form-label">Subject Line Prefix</label>
                <input 
                  type="text"
                  className="form-input"
                  value={this.state.subject_prefix}
                  onChange={(e) => this.setState({subject_prefix: e.target.value})}
                  placeholder="e.g., [SPAM] or [FILTERED]"
                />
                <div className="form-help">Text to add to the beginning of spam message subjects</div>
              </div>

              <div className="text-center">
                <button type="submit" className="btn btn-primary btn-lg">
                  Save Email Settings
                </button>
              </div>
            </form>
          </div>
        </div>
      </Section>
    );
  }

  render() {
    return <div className="account-settings">
    {this.accountSettingsSection()}
    {this.emailAddressesSection()}
    {this.emailSettingsSection()}
    </div>
  }
}

export default AccountSettings;